import React, { useMemo } from 'react'
import { Expander, ExpanderHeader, ExpanderContent, Button, Separator, useOverlay } from '@fs/zion-ui'
import { MenuClose, MenuNewWindow, PlaceLowerDivision } from '@fs/zion-icon/dist/cjs/icons'
import { baseUrl } from '@fs/zion-config'
import { useFeatureFlag } from '@fs/zion-flags'
import ApplyWatermarkDialog from './ApplyWatermarkDialog'
import transl from './Watermarking.transl'
import RemoveWatermarkDialog from './RemoveWatermarkDialog'

export default function Watermarking({ currentApid, groupId, properties }) {
  const removeWatermarkFlag = useFeatureFlag('lightyear_lightyearReact_showRemoveWatermarksButton')
  const applyWatermarkOverlay = useOverlay()
  const removeWatermarkOverlay = useOverlay()

  const hasLegacyWatermark = useMemo(() => {
    return properties?.find((prop) => prop.name === 'hasLegacyWatermark')?.values[0]?.toLowerCase() === 'true'
  }, [properties])

  return (
    <>
      <Expander>
        <ExpanderHeader>{transl.watermarking()}</ExpanderHeader>
        <ExpanderContent>
          <Separator size="xxs" />
          <Button
            data-testid="openApplyWatermarkModal"
            Icon={PlaceLowerDivision}
            onClick={applyWatermarkOverlay.handleClick}
          >
            {transl.applyWatermark()}
          </Button>
          <br />
          {removeWatermarkFlag.isOn && (
            <>
              <Button
                data-testid="openRemoveWatermarkModal"
                Icon={MenuClose}
                onClick={removeWatermarkOverlay.handleClick}
              >
                {transl.removeWatermarks()}
              </Button>
              <br />
            </>
          )}
          <Button
            data-testid="goToWatermarkEditor"
            Icon={MenuNewWindow}
            to={`${baseUrl}/records/home/watermarking`}
            target="_blank"
          >
            {transl.watermarkEditor()}
          </Button>
        </ExpanderContent>
      </Expander>
      {applyWatermarkOverlay.isOpen && (
        <ApplyWatermarkDialog
          overlay={applyWatermarkOverlay}
          currentApid={currentApid}
          groupId={groupId}
          hasLegacyWatermark={hasLegacyWatermark}
        />
      )}
      <RemoveWatermarkDialog overlay={removeWatermarkOverlay} groupId={groupId} />
    </>
  )
}
